import axios from 'axios'
import { ThunkAction } from 'store/types'
import * as actions from './actions'

const getDataLink = (data: Blob, options?: any) => {
  console.log("getDataLink", options)
  const url = window.URL.createObjectURL(data)
  const link: any = document.createElement('a')
  link.href = url
  link.target = '_blank'
  if (options) {
    for (const prop in options) {
      link[prop] = options[prop]
    }
  }
  return link
}

const generateCmsReport = async (reportType : string) => {
  // @ts-ignore
  const URL = `/cms/reports?reportType=` + reportType;
  const accept = reportType === 'pdf' ? "application/pdf" : "text/csv"
  return await axios.get(URL, {
    responseType: 'blob',
    headers: {
      Accept: accept
    }
  })
}

export const printCmsPdf = (): ThunkAction => {
  return async (dispatch, getStore) => {
    dispatch(actions.getCmsPDFRequest())
    try {
      const resp = await generateCmsReport("pdf")
      const link = getDataLink(resp.data)
      link.click()
      dispatch(actions.getCmsPDFSuccess())
    } catch (err) {
      dispatch(actions.getCmsPDFFail(err.response))
      console.log('err', err)
    }
  }
}

export const downloadCmsPdf = (): ThunkAction => {
  return async (dispatch) => {
    dispatch(actions.getCmsPDFRequest())
    try {
      const resp = await generateCmsReport("pdf")
      const link = getDataLink(resp.data, {
        download: 'price_transparency.pdf'
      })
      link.click()
      dispatch(actions.getCmsPDFSuccess())
    } catch (err) {
      dispatch(actions.getCmsPDFFail(err.response))
      console.log('err', err)
    }
  }
}

export const downloadCmsCsv = (): ThunkAction => {
  return async (dispatch) => {
    dispatch(actions.getCmsPDFRequest())
    try {
      const resp = await generateCmsReport("csv")
      console.log("Response ", resp)
      const link = getDataLink(resp.data, {
        download: '8123456_Friendly_Hospital_standardchargers.csv'
      })
      link.click()
      dispatch(actions.getCmsPDFSuccess())
    } catch (err) {
      dispatch(actions.getCmsPDFFail(err.response))
      console.log('err', err)
    }
  }
}